document.addEventListener('DOMContentLoaded', function() {
  $('.Faq__NavLink').on("click", function (event) {
    event.preventDefault();

    var id  = $(this).attr('href'),
        top = $(id).offset().top - document.querySelector('.Header').offsetHeight + 'px';

    $('body,html').animate({scrollTop: top}, 1000);

    if(!$(this).hasClass('active')) {
      $('.Faq__NavLink').removeClass('active');
      $(this).addClass('active');
    }
  });

  if (window.location.href.indexOf("#where-to-buy-avaline") > -1) {
   $('[data-group-id="where-to-buy-avaline"]')[1].click();
  }
});